import { Sizes } from '@sede-enterprise/shell-ds-react-framework';
import {
  HeaderSubText,
  HeaderText,
  HeaderTextWrapper,
  ShellNavBar,
  ShellNavWrapper,
} from 'components/NavBar/NavBar.styled';

export const NavbarLean = () => {
  return (
    <ShellNavWrapper>
      <ShellNavBar
        size={Sizes.Large}
        data-testid="shell-navbar"
        header={
          <>
            <HeaderTextWrapper>
              <HeaderSubText>Shell Energy</HeaderSubText>
              <HeaderText>Battery Management Hub</HeaderText>
            </HeaderTextWrapper>
          </>
        }
      />
    </ShellNavWrapper>
  );
};
